import { useTranslation } from 'react-i18next';

const AcademySection = () => {
  const { t } = useTranslation();

  return (
    <section className="relative py-24 overflow-hidden bg-[#050008]">

      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          {/* Left Content */}
          <div className="flex-1 text-center lg:text-left">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-[#8c52ff]/10 border border-[#8c52ff]/30 rounded-full px-4 py-2 mb-6">
              <i className="ri-graduation-cap-line text-[#8c52ff] text-sm" />
              <span className="text-[#8c52ff] text-xs font-bold uppercase tracking-widest">{t('home.academy.badge')}</span>
            </div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-black text-white mb-6 leading-tight">
              {t('home.academy.titleMain')}
              <span className="block bg-gradient-to-r from-[#8c52ff] to-[#00c2ff] bg-clip-text text-transparent">
                {t('home.academy.titleHighlight')}
              </span>
            </h2>

            <p className="text-white/60 text-base md:text-lg leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              {t('home.academy.subtitle')}
            </p>

            <ul className="space-y-3 mb-10 text-left max-w-md mx-auto lg:mx-0">
              {(t('home.academy.benefits', { returnObjects: true }) as string[]).map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center rounded-full bg-[#8c52ff]/20 flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-[#8c52ff] text-xs" />
                  </div>
                  <span className="text-white/70 text-sm">{item}</span>
                </li>
              ))}
            </ul>

            <a
              href="https://smartbusiness.academy"
              target="_blank"
              rel="noopener noreferrer"
              className="whitespace-nowrap inline-flex items-center gap-3 bg-gradient-to-r from-[#8c52ff] to-[#00c2ff] text-white font-bold px-8 py-4 rounded-full hover:opacity-90 hover:scale-105 transition-all duration-300 text-base shadow-lg shadow-purple-500/30 cursor-pointer"
            >
              <i className="ri-graduation-cap-line" />
              {t('home.academy.button')}
              <i className="ri-external-link-line text-sm" />
            </a>
          </div>

          {/* Right Visual */}
          <div className="flex-1 relative flex justify-center">
            <div className="relative w-full max-w-lg">
              {/* Main image */}
              <div className="relative rounded-3xl overflow-hidden border border-white/10">
                <img
                  src="https://readdy.ai/api/search-image?query=online%20learning%20academy%20digital%20education%20platform%20laptop%20screen%20courses%20purple%20blue%20glowing%20modern%20futuristic%20latina%20students%20success&width=600&height=450&seq=academy1&orientation=landscape"
                  alt="Smart Business Academy"
                  className="w-full h-96 md:h-[480px] object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#050008]/80 via-transparent to-transparent" />
                <div className="absolute bottom-6 left-6 right-6">
                  <div className="bg-black/60 backdrop-blur-xl border border-white/10 rounded-2xl p-4">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-gradient-to-br from-[#8c52ff] to-[#00c2ff]">
                        <i className="ri-play-line text-white" />
                      </div>
                      <div>
                        <div className="text-white font-bold text-sm">{t('home.academy.visual.module')}</div>
                        <div className="text-white/50 text-xs">{t('home.academy.visual.topic')}</div>
                      </div>
                    </div>
                    <div className="w-full bg-white/10 rounded-full h-1.5">
                      <div className="bg-gradient-to-r from-[#8c52ff] to-[#00c2ff] h-1.5 rounded-full w-3/5" />
                    </div>
                    <div className="flex justify-between mt-1">
                      <span className="text-white/40 text-xs">60% {t('home.academy.visual.completed')}</span>
                      <span className="text-[#8c52ff] text-xs font-semibold">{t('home.academy.visual.status')}</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Floating stats */}
              <div className="absolute -top-4 -right-4 bg-black/80 backdrop-blur-xl border border-[#FF2DAA]/30 rounded-2xl px-4 py-3">
                <div className="text-[#FF2DAA] font-black text-2xl">500+</div>
                <div className="text-white/50 text-xs">{t('home.academy.stats.students')}</div>
              </div>
              <div className="absolute -bottom-4 -left-4 bg-black/80 backdrop-blur-xl border border-[#00c2ff]/30 rounded-2xl px-4 py-3">
                <div className="flex items-center gap-1 mb-1">
                  {[1,2,3,4,5].map((s) => (
                    <i key={s} className="ri-star-fill text-yellow-400 text-xs" />
                  ))}
                </div>
                <div className="text-white/50 text-xs">4.9/5 {t('home.academy.stats.rating')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AcademySection;
